import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { signinRedirectCallback } from './userManager';
import { RouteNames } from '../constants/Routes';

const SIGNIN_RETURN_PATH_KEY = 'signin:returnPath';

function sanitizeReturnPath(path) {
	if (typeof path !== 'string' || !path.startsWith('/')) {
		return RouteNames.DASHBOARD;
	}

	if (
		path === RouteNames.SIGNIN ||
		path === RouteNames.SIGNOUT ||
		path.endsWith(RouteNames.SILENT_RENEW)
	) {
		return RouteNames.DASHBOARD;
	}

	return path;
}

function SigninOidc() {
	const navigate = useNavigate();
	useEffect(() => {
		async function signinAsync() {
			try {
				const user = await signinRedirectCallback();
				const callbackReturnPath =
					user?.state?.returnPath || user?.state?.returnTo;
				const storedReturnPath = sessionStorage.getItem(SIGNIN_RETURN_PATH_KEY);
				const returnPath = callbackReturnPath || storedReturnPath;
				sessionStorage.removeItem(SIGNIN_RETURN_PATH_KEY);
				navigate(sanitizeReturnPath(returnPath), { replace: true });
			} catch (err) {
				console.error(err);
				sessionStorage.removeItem(SIGNIN_RETURN_PATH_KEY);
				navigate(RouteNames.DASHBOARD, { replace: true });
			}
		}
		signinAsync();
	}, [navigate]);

	return null;
}

export default SigninOidc;
